import { create } from 'zustand';
import { DEFAULT_CLIENT_SEARCH_CRITERION } from '../constants/clientSearchCriteria';

export const buildDefaultTaskFilters = () => ({
  clientSearchCriteria: DEFAULT_CLIENT_SEARCH_CRITERION,
  clientSearchValue: '',
  type: '',
  priority: '',
  team: '',
  status: '',
  validation: '',
  dateType: 'today',
  customDateFrom: '',
  customDateTo: '',
  date: new Date().toISOString().slice(0, 10)
});

export const useTaskManagementFiltersStore = create((set) => ({
  filters: buildDefaultTaskFilters(),
  currentPage: 1,
  pageSize: 10,
  viewMode: 'list',
  setFilters: (filters) => set({ filters }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setPageSize: (pageSize) => set({ pageSize }),
  setViewMode: (viewMode) => set({ viewMode }),
  resetFilters: () => set({
    filters: buildDefaultTaskFilters(),
    currentPage: 1
  })
}));
